<template>
  <div>
    <b-modal
      v-model="showModal"
      title="Confirmation"
      hide-footer
    >
      <p>Are you sure you want to dispose this asset?</p>
      <b-button
variant="danger"
@click="disposeAsset"
>
Yes
</b-button>&nbsp;
      <b-button @click="hideModal">
No
</b-button>
    </b-modal>

    <b-modal
      id="modal-upload"
      v-model="modalUpload"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      title="Documents"
    >
      <b-form>
        <div class="messages">
          <ul
            v-if="documentsList.length > 0"
            class="list-group"
            style="height:300px;width:100%;overflow-y:scroll"
          >
            <input
              id="materialRequestId"
              ref="invoiceMessage"
              v-model="materialRequestId"
              type="hidden"
              name="materialRequestId"
            >
            <li
              v-for="item in documentsList"
              :key="item.document_id"
              class="list-group-item d-flex justify-content-between align-items-center"
              style="cursor: pointer;"
            >
              <span style="font-size:9px">{{ item.document_file_name }}</span>
              <div>
                <b-button
                  :disabled="item.document_old"
                  variant="primary"
                  size="sm"
                  class="mr-1"
                  @click.stop="downloadAttachment(item)"
                >
                  <feather-icon icon="DownloadIcon" />
                </b-button>
                <b-button
                  variant="danger"
                  size="sm"
                  @click.stop="deleteAttachment(item)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>
            </li>
          </ul>
          <div v-if="documentsList.length === 0">
No Files
</div>
          <br>
          <form
id="send_file_form"
method="post"
action=""
@submit.prevent="sendfiles"
>
            <b-row>
              <b-col
cols="11"
md="9"
>
                <b-form-file
                  id="file"
                  ref="uploadFile"
                  placeholder="Choose one file or drop it here..."
                  drop-placeholder="Drop a file here..."
                  type="file"
                  @change="handleFilesUpload"
                />
                <div
class="alert alert-info mt-1"
role="alert"
>
Max file upload is 20MB
</div>
              </b-col>
              <b-col
cols="11"
md="3"
>
                <input
                  type="button"
                  class="btn btn-primary pull-right"
                  value="Send"
                  @click="sendDocument()"
                >
              </b-col>
            </b-row>
          </form>
        </div>
      </b-form>
    </b-modal>

    <div class="mb-2 d-flex justify-content-end">
      <b-button
        v-if="hasPermission('assets_create')"
        type="button"
        variant="primary"
        @click.stop.prevent="navigateToAddAsset"
      >
        <feather-icon icon="PlusIcon" />
        <span class="text-nowrap">Add Asset</span>
      </b-button>
    </div>

    <b-card
no-body
class="mb-0"
>
      <b-tabs v-model="activeOuterTab">
        <!-- ===================== ACTIVE ===================== -->
        <b-tab title="Active">
          <DataTableToolbar
            id="toolbar-active"
            :branch.sync="filterBranch"
            :asset-group.sync="filterAssetGroup"
            :asset-status.sync="filterAssetStatus"
            :start-date.sync="startDateFilter"
            :end-date.sync="endDateFilter"
            :per-page.sync="perPage"
            :search-query.sync="searchQuery"
            :branches="branches"
            :asset-groups="assetGroups"
            :asset-status-options="assetStatusOptions"
            :per-page-options="perPageOptions"
            :is-loading-excel="exportLoading.active.xlsx"
            :is-loading-pdf="exportLoading.active.pdf"
            @export-excel="exportAsset('active', 'xlsx')"
            @export-pdf="exportAsset('active', 'pdf')"
          />

          <div class="d-flex justify-content-end px-1 mb-1">
            <div
              class="view-switch"
              role="group"
              aria-label="View mode"
            >
              <button
                type="button"
                class="view-switch__btn"
                :class="{ 'view-switch__btn--active': viewMode === 'card' }"
                @click="viewMode = 'card'"
              >
                <feather-icon
                  icon="GridIcon"
                  size="14"
                />
                <span>Cards</span>
              </button>
              <button
                type="button"
                class="view-switch__btn"
                :class="{ 'view-switch__btn--active': viewMode === 'table' }"
                @click="viewMode = 'table'"
              >
                <feather-icon
                  icon="ListIcon"
                  size="14"
                />
                <span>Table</span>
              </button>
            </div>
          </div>

          <b-table
            v-if="viewMode === 'table'"
            ref="refAssetsListTable"
            class="position-relative"
            :items="fetchAssets"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            :sort-desc.sync="isSortDirDesc"
            show-empty
            empty-text="No matching records found"
          >
            <template #table-busy>
              <shimmer-table-rows
                :rows="Math.min(perPage, 8)"
                :columns="tableColumns.length - 1"
              />
            </template>
            <template #cell(AssetID)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{ data.item.asset_number }}</span>
                <label
                  v-if="isOldAsset(data.item)"
                  class="ml-1 mb-0 badge badge-secondary"
                >Old</label>
                <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
              </div>
            </template>
            <template #cell(ItemName)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
              </div>
            </template>
            <template #cell(Origin)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{ cutString(data.item.origin ? data.item.origin.branch_name : '-') }}</span>
              </div>
            </template>
            <template #cell(CurrentLocation)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{ cutString(data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-')) }}</span>
              </div>
            </template>
            <template #cell(CurrentCondition)="data">
              <div class="text-nowrap">
                <span class="align-text-top text-capitalize">{{ data.item.asset_condition }}</span>
              </div>
            </template>
            <template #cell(CurrentStatus)="data">
              <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
                {{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
              </b-badge>
            </template>
            <template #cell(Thumbnail)="data">
              <AssetPhotoAction
                v-if="data.item.asset_photo"
                :filename="data.item.asset_photo"
                @preview="showPhotoPreview(data.item)"
              />
              <div
v-else
class="text-center"
>
                <b-badge variant="warning">
No Photo
</b-badge>
              </div>
            </template>
            <template #cell(DateCreated)="data">
              {{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
            </template>
            <template #cell(DateModified)="data">
              {{ dateSimple(data.item.asset_updated_time, 'YYYY-MM-DD HH:mm:ss') }}
            </template>
            <template #cell(actions)="data">
              <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                <template #button-content>
                  <feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
                </template>
                <b-dropdown-item @click="showDetail(data.item)">
                  <feather-icon icon="ZoomInIcon" />
                  <span class="align-middle ml-50">Detail</span>
                </b-dropdown-item>
                <b-dropdown-item @click="showHistory(data.item)">
                  <feather-icon icon="BookIcon" />
                  <span class="align-middle ml-50">History</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="userRole === 'finance' && !data.item.asset_is_disposed"
                  @click="disposeAssetRoute(data.item)"
                >
                  <feather-icon icon="Trash2Icon" />
                  <span class="align-middle ml-50">Dispose</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="userRole === 'finance' && !data.item.asset_is_disposed"
                  @click="updateAsset(data.item)"
                >
                  <feather-icon icon="RefreshCwIcon" />
                  <span class="align-middle ml-50">Update Status</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>

          <div
            v-if="viewMode === 'card'"
            class="asset-cards"
          >
            <div
              v-if="isLoadingActiveCards"
              class="asset-cards__loading"
            >
              <shimmer-card-grid :count="perPage" />
            </div>

            <div
              v-else-if="activeCardItems.length === 0"
              class="asset-cards__empty"
            >
              <feather-icon
                icon="BoxIcon"
                size="34"
              />
              <p class="mb-0 mt-1">
                No matching records found
              </p>
            </div>

            <div
              v-else
              class="asset-cards__body"
            >
              <div class="asset-cards__rail d-none d-md-flex">
                <button
                  v-for="letter in alphabet"
                  :key="letter"
                  type="button"
                  class="asset-cards__rail-letter"
                  :class="{ 'asset-cards__rail-letter--active': availableLetters.has(letter) }"
                  :disabled="!availableLetters.has(letter)"
                  @click="scrollToLetter(letter)"
                >
                  {{ letter }}
                </button>
              </div>

              <div
                ref="assetCardScrollArea"
                class="asset-cards__scroll"
              >
                <div
                  v-for="group in groupedActiveCards"
                  :id="`asset-letter-${group.letter}`"
                  :key="group.letter"
                  class="asset-cards__group"
                >
                  <div class="asset-cards__group-heading">
                    <span>{{ group.letter }}</span>
                    <em>{{ group.items.length }} asset{{ group.items.length === 1 ? '' : 's' }}</em>
                  </div>

                  <div class="asset-cards__grid">
                    <div
                      v-for="item in group.items"
                      :key="item.asset_id"
                      class="asset-card"
                    >
                      <div class="asset-card__top">
                        <span class="asset-card__icon">
                          <feather-icon
                            icon="BoxIcon"
                            size="20"
                          />
                        </span>
                        <b-dropdown
                          variant="link"
                          no-caret
                          toggle-class="p-0 asset-card__menu"
                          :right="$store.state.appConfig.isRTL"
                        >
                          <template #button-content>
                            <feather-icon
                              icon="MoreVerticalIcon"
                              size="16"
                              class="align-middle text-body"
                            />
                          </template>
                          <b-dropdown-item @click="showDetail(item)">
                            <feather-icon icon="ZoomInIcon" />
                            <span class="align-middle ml-50">Detail</span>
                          </b-dropdown-item>
                          <b-dropdown-item @click="showHistory(item)">
                            <feather-icon icon="BookIcon" />
                            <span class="align-middle ml-50">History</span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="userRole === 'finance' && !item.asset_is_disposed"
                            @click="disposeAssetRoute(item)"
                          >
                            <feather-icon icon="Trash2Icon" />
                            <span class="align-middle ml-50">Dispose</span>
                          </b-dropdown-item>
                          <b-dropdown-item
                            v-if="userRole === 'finance' && !item.asset_is_disposed"
                            @click="updateAsset(item)"
                          >
                            <feather-icon icon="RefreshCwIcon" />
                            <span class="align-middle ml-50">Update Status</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>

                      <h6 class="asset-card__name">
                        {{ item.item ? item.item.item_name : '-' }}
                      </h6>

                      <div class="asset-card__badges">
                        <b-badge
                          pill
                          :variant="isOldAsset(item) ? 'secondary' : 'success'"
                        >
                          {{ isOldAsset(item) ? 'Old' : 'New' }}
                        </b-badge>
                        <b-badge
                          pill
                          :variant="resolveStatusVariant(item.asset_status)"
                        >
                          {{ item.asset_status ? item.asset_status.toUpperCase() : 'ACTIVE' }}
                        </b-badge>
                      </div>

                      <ul class="asset-card__meta">
                        <li>
                          <feather-icon
                            icon="HashIcon"
                            size="13"
                          />
                          <span>{{ item.asset_number }}</span>
                        </li>
                        <li>
                          <feather-icon
                            icon="MapPinIcon"
                            size="13"
                          />
                          <span>{{ cutString(item.current ? item.current.branch_name : (item.origin ? item.origin.branch_name : '-')) }}</span>
                        </li>
                        <li>
                          <feather-icon
                            icon="ToolIcon"
                            size="13"
                          />
                          <span class="text-capitalize">{{ item.asset_condition || '-' }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <DataTableFooter
            id="footer-active"
            :from="dataMeta.from"
            :to="dataMeta.to"
            :of="dataMeta.of"
            :total="totalItems"
            :per-page="perPage"
            :current-page.sync="currentPage"
          />
        </b-tab>

        <!-- ===================== UPDATE ===================== -->
        <b-tab title="Update">
          <b-tabs v-model="activeUpdateStatusTab">
            <b-tab title="On Going">
              <DataTableToolbar
                id="toolbar-update-on-going"
                :branch.sync="filterBranchUpdateOnGoing"
                :asset-group.sync="filterAssetGroupUpdateOnGoing"
                :asset-status.sync="filterAssetStatusUpdateOnGoing"
                :start-date.sync="startDateFilterUpdateOnGoing"
                :end-date.sync="endDateFilterUpdateOnGoing"
                :per-page.sync="perPageUpdateOnGoing"
                :search-query.sync="searchQueryUpdateOnGoing"
                :branches="branches"
                :asset-groups="assetGroups"
                :asset-status-options="assetStatusOptions"
                :per-page-options="perPageOptions"
                :is-loading-excel="exportLoading.updateOnGoing.xlsx"
                :is-loading-pdf="exportLoading.updateOnGoing.pdf"
                @export-excel="exportAsset('updateOnGoing', 'xlsx')"
                @export-pdf="exportAsset('updateOnGoing', 'pdf')"
              />
              <b-table
                ref="refAssetsListTableUpdateOnGoing"
                class="position-relative"
                :items="fetchAssetsUpdateOnGoing"
                responsive
                :fields="tableColumnsUpdated"
                primary-key="id"
                :sort-by.sync="sortByUpdateOnGoing"
                :sort-desc.sync="isSortDirDescUpdateOnGoing"
                show-empty
                empty-text="No matching records found"
              >
                <template #table-busy>
                  <shimmer-table-rows
                    :rows="Math.min(perPageUpdateOnGoing, 8)"
                    :columns="tableColumnsUpdated.length - 1"
                  />
                </template>
                <template #cell(AssetID)="data">
                  <span class="text-capitalize">{{ data.item.asset_number }}</span>
                  <label
v-if="isOldAsset(data.item)"
class="ml-1 mb-0 badge badge-secondary"
>Old</label>
                  <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
                </template>
                <template #cell(ItemName)="data">
<span class="text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
</template>
                <template #cell(Origin)="data">
<span class="text-capitalize">{{ data.item.origin ? data.item.origin.branch_name : '-' }}</span>
</template>
                <template #cell(CurrentLocation)="data">
<span class="text-capitalize">{{ data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-') }}</span>
</template>
                <template #cell(CurrentCondition)="data">
<span class="text-capitalize">{{ data.item.asset_condition }}</span>
</template>
                <template #cell(CurrentStatus)="data">
                  <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
{{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
</b-badge>
                </template>
                <template #cell(Thumbnail)="data">
                  <AssetPhotoAction
v-if="data.item.asset_photo"
:filename="data.item.asset_photo"
@preview="showPhotoPreview(data.item)"
/>
                  <div
v-else
class="text-center"
>
<b-badge variant="warning">
No Photo
</b-badge>
</div>
                </template>
                <template #cell(DateCreated)="data">
{{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(DateUpdated)="data">
{{ dateSimple(data.item.asset_updated_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(actions)="data">
                  <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                    <template #button-content>
<feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
</template>
                    <b-dropdown-item @click="showUpdateApproval(data.item)">
<feather-icon icon="CheckSquareIcon" /><span class="align-middle ml-50">Review & Confirm</span>
</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <DataTableFooter
                id="footer-update-on-going"
                :from="dataMetaUpdateOnGoing.from"
                :to="dataMetaUpdateOnGoing.to"
                :of="dataMetaUpdateOnGoing.of"
                :total="totalItemsUpdateOnGoing"
                :per-page="perPageUpdateOnGoing"
                :current-page.sync="currentPageUpdateOnGoing"
              />
            </b-tab>

            <b-tab title="Needs Approval">
              <DataTableToolbar
                id="toolbar-update-na"
                :branch.sync="filterBranchUpdateNA"
                :asset-group.sync="filterAssetGroupUpdateNA"
                :asset-status.sync="filterAssetStatusUpdateNA"
                :start-date.sync="startDateFilterUpdateNA"
                :end-date.sync="endDateFilterUpdateNA"
                :per-page.sync="perPageUpdateNA"
                :search-query.sync="searchQueryUpdateNA"
                :branches="branches"
                :asset-groups="assetGroups"
                :asset-status-options="assetStatusOptions"
                :per-page-options="perPageOptions"
                :is-loading-excel="exportLoading.updateNA.xlsx"
                :is-loading-pdf="exportLoading.updateNA.pdf"
                @export-excel="exportAsset('updateNA', 'xlsx')"
                @export-pdf="exportAsset('updateNA', 'pdf')"
              />
              <b-table
                id="table-update-na"
                ref="refAssetsListTableUpdateNA"
                class="position-relative"
                :items="fetchAssetsUpdateNA"
                responsive
                :fields="tableColumnsUpdated"
                primary-key="id"
                :sort-by.sync="sortByUpdateNA"
                :sort-desc.sync="isSortDirDescUpdateNA"
                show-empty
                empty-text="No matching records found"
              >
                <template #table-busy>
                  <shimmer-table-rows
                    :rows="Math.min(perPageUpdateNA, 8)"
                    :columns="tableColumnsUpdated.length - 1"
                  />
                </template>
                <template #cell(AssetID)="data">
                  <span class="text-capitalize">{{ data.item.asset_number }}</span>
                  <label
v-if="isOldAsset(data.item)"
class="ml-1 mb-0 badge badge-secondary"
>Old</label>
                  <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
                </template>
                <template #cell(ItemName)="data">
<span class="text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
</template>
                <template #cell(Origin)="data">
<span class="text-capitalize">{{ data.item.origin ? data.item.origin.branch_name : '-' }}</span>
</template>
                <template #cell(CurrentLocation)="data">
<span class="text-capitalize">{{ data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-') }}</span>
</template>
                <template #cell(CurrentCondition)="data">
<span class="text-capitalize">{{ data.item.asset_condition }}</span>
</template>
                <template #cell(CurrentStatus)="data">
                  <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
{{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
</b-badge>
                </template>
                <template #cell(Thumbnail)="data">
                  <AssetPhotoAction
v-if="data.item.asset_photo"
:filename="data.item.asset_photo"
@preview="showPhotoPreview(data.item)"
/>
                  <div
v-else
class="text-center"
>
<b-badge variant="warning">
No Photo
</b-badge>
</div>
                </template>
                <template #cell(DateCreated)="data">
{{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(DateUpdated)="data">
{{ dateSimple(data.item.asset_updated_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(actions)="data">
                  <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                    <template #button-content>
<feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
</template>
                    <b-dropdown-item @click="showUpdateApproval(data.item)">
<feather-icon icon="CheckSquareIcon" /><span class="align-middle ml-50">Review & Confirm</span>
</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <DataTableFooter
                id="footer-update-na"
                :from="dataMetaUpdateNA.from"
                :to="dataMetaUpdateNA.to"
                :of="dataMetaUpdateNA.of"
                :total="totalItemsUpdateNA"
                :per-page="perPageUpdateNA"
                :current-page.sync="currentPageUpdateNA"
              />
            </b-tab>

            <b-tab title="Updated">
              <DataTableToolbar
                id="toolbar-updated"
                :branch.sync="filterBranchUpdated"
                :asset-group.sync="filterAssetGroupUpdated"
                :asset-status.sync="filterAssetStatusUpdated"
                :start-date.sync="startDateFilterUpdated"
                :end-date.sync="endDateFilterUpdated"
                :per-page.sync="perPageUpdated"
                :search-query.sync="searchQueryUpdated"
                :branches="branches"
                :asset-groups="assetGroups"
                :asset-status-options="assetStatusOptions"
                :per-page-options="perPageOptions"
                :is-loading-excel="exportLoading.updated.xlsx"
                :is-loading-pdf="exportLoading.updated.pdf"
                @export-excel="exportAsset('updated', 'xlsx')"
                @export-pdf="exportAsset('updated', 'pdf')"
              />
              <b-table
                ref="refAssetsListTableUpdated"
                class="position-relative"
                :items="fetchAssetsUpdated"
                responsive
                :fields="tableColumnsUpdated"
                primary-key="id"
                :sort-by.sync="sortByUpdated"
                :sort-desc.sync="isSortDirDescUpdated"
                show-empty
                empty-text="No matching records found"
              >
                <template #table-busy>
                  <shimmer-table-rows
                    :rows="Math.min(perPageUpdated, 8)"
                    :columns="tableColumnsUpdated.length - 1"
                  />
                </template>
                <template #cell(AssetID)="data">
                  <span class="text-capitalize">{{ data.item.asset_number }}</span>
                  <label
v-if="isOldAsset(data.item)"
class="ml-1 mb-0 badge badge-secondary"
>Old</label>
                  <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
                </template>
                <template #cell(ItemName)="data">
<span class="text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
</template>
                <template #cell(Origin)="data">
<span class="text-capitalize">{{ data.item.origin ? data.item.origin.branch_name : '-' }}</span>
</template>
                <template #cell(CurrentLocation)="data">
<span class="text-capitalize">{{ data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-') }}</span>
</template>
                <template #cell(CurrentCondition)="data">
<span class="text-capitalize">{{ data.item.asset_condition }}</span>
</template>
                <template #cell(CurrentStatus)="data">
                  <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
{{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
</b-badge>
                </template>
                <template #cell(Thumbnail)="data">
                  <AssetPhotoAction
v-if="data.item.asset_photo"
:filename="data.item.asset_photo"
@preview="showPhotoPreview(data.item)"
/>
                  <div
v-else
class="text-center"
>
<b-badge variant="warning">
No Photo
</b-badge>
</div>
                </template>
                <template #cell(DateCreated)="data">
{{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(DateUpdated)="data">
{{ dateSimple(data.item.asset_is_updated_confirmed_by_fa_coal_manager_date, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(actions)="data">
                  <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                    <template #button-content>
<feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
</template>
                    <b-dropdown-item @click="showDetail(data.item)">
<feather-icon icon="ZoomInIcon" /><span class="align-middle ml-50">Detail</span>
</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <DataTableFooter
                id="footer-updated"
                :from="dataMetaUpdated.from"
                :to="dataMetaUpdated.to"
                :of="dataMetaUpdated.of"
                :total="totalItemsUpdated"
                :per-page="perPageUpdated"
                :current-page.sync="currentPageUpdated"
              />
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- ===================== DISPOSE ===================== -->
        <b-tab title="Dispose">
          <b-tabs v-model="activeDisposeStatusTab">
            <b-tab title="On Going">
              <DataTableToolbar
                id="toolbar-dispose-on-going"
                :branch.sync="filterBranchOnGoing"
                :asset-group.sync="filterAssetGroupOnGoing"
                :asset-status.sync="filterAssetStatusOnGoing"
                :start-date.sync="startDateFilterOnGoing"
                :end-date.sync="endDateFilterOnGoing"
                :per-page.sync="perPageOnGoing"
                :search-query.sync="searchQueryOnGoing"
                :branches="branches"
                :asset-groups="assetGroups"
                :asset-status-options="assetStatusOptions"
                :per-page-options="perPageOptions"
                :is-loading-excel="exportLoading.disposeOnGoing.xlsx"
                :is-loading-pdf="exportLoading.disposeOnGoing.pdf"
                @export-excel="exportAsset('disposeOnGoing', 'xlsx')"
                @export-pdf="exportAsset('disposeOnGoing', 'pdf')"
              />
              <b-table
                ref="refAssetsListTableOnGoing"
                class="position-relative"
                :items="fetchAssetsOnGoing"
                responsive
                :fields="tableColumnsDisposed"
                primary-key="id"
                :sort-by.sync="sortByOnGoing"
                :sort-desc.sync="isSortDirDescOnGoing"
                show-empty
                empty-text="No matching records found"
              >
                <template #table-busy>
                  <shimmer-table-rows
                    :rows="Math.min(perPageOnGoing, 8)"
                    :columns="tableColumnsDisposed.length - 1"
                  />
                </template>
                <template #cell(AssetID)="data">
                  <span class="text-capitalize">{{ data.item.asset_number }}</span>
                  <label
v-if="isOldAsset(data.item)"
class="ml-1 mb-0 badge badge-secondary"
>Old</label>
                  <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
                </template>
                <template #cell(ItemName)="data">
<span class="text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
</template>
                <template #cell(Origin)="data">
<span class="text-capitalize">{{ data.item.origin ? data.item.origin.branch_name : '-' }}</span>
</template>
                <template #cell(CurrentLocation)="data">
<span class="text-capitalize">{{ data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-') }}</span>
</template>
                <template #cell(CurrentCondition)="data">
<span class="text-capitalize">{{ data.item.asset_condition }}</span>
</template>
                <template #cell(CurrentStatus)="data">
                  <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
{{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
</b-badge>
                </template>
                <template #cell(Thumbnail)="data">
                  <AssetPhotoAction
v-if="data.item.asset_photo"
:filename="data.item.asset_photo"
@preview="showPhotoPreview(data.item)"
/>
                  <div
v-else
class="text-center"
>
<b-badge variant="warning">
No Photo
</b-badge>
</div>
                </template>
                <template #cell(DateCreated)="data">
{{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(DateDisposed)="data">
{{ dateSimple(data.item.asset_disposed_date, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(actions)="data">
                  <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                    <template #button-content>
<feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
</template>
                    <b-dropdown-item @click="showDetailDisposal(data.item)">
<feather-icon icon="ZoomInIcon" /><span class="align-middle ml-50">Detail</span>
</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <DataTableFooter
                id="footer-dispose-on-going"
                :from="dataMetaOnGoing.from"
                :to="dataMetaOnGoing.to"
                :of="dataMetaOnGoing.of"
                :total="totalItemsOnGoing"
                :per-page="perPageOnGoing"
                :current-page.sync="currentPageOnGoing"
              />
            </b-tab>

            <b-tab title="Needs Approval">
              <DataTableToolbar
                id="toolbar-dispose-na"
                :branch.sync="filterBranchNA"
                :asset-group.sync="filterAssetGroupNA"
                :asset-status.sync="filterAssetStatusNA"
                :start-date.sync="startDateFilterNA"
                :end-date.sync="endDateFilterNA"
                :per-page.sync="perPageNA"
                :search-query.sync="searchQueryNA"
                :branches="branches"
                :asset-groups="assetGroups"
                :asset-status-options="assetStatusOptions"
                :per-page-options="perPageOptions"
                :is-loading-excel="exportLoading.disposeNA.xlsx"
                :is-loading-pdf="exportLoading.disposeNA.pdf"
                @export-excel="exportAsset('disposeNA', 'xlsx')"
                @export-pdf="exportAsset('disposeNA', 'pdf')"
              />
              <b-table
                ref="refAssetsListTableNA"
                class="position-relative"
                :items="fetchAssetsNA"
                responsive
                :fields="tableColumnsDisposed"
                primary-key="id"
                :sort-by.sync="sortByNA"
                :sort-desc.sync="isSortDirDescNA"
                show-empty
                empty-text="No matching records found"
              >
                <template #table-busy>
                  <shimmer-table-rows
                    :rows="Math.min(perPageNA, 8)"
                    :columns="tableColumnsDisposed.length - 1"
                  />
                </template>
                <template #cell(AssetID)="data">
                  <span class="text-capitalize">{{ data.item.asset_number }}</span>
                  <label
v-if="isOldAsset(data.item)"
class="ml-1 mb-0 badge badge-secondary"
>Old</label>
                  <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
                </template>
                <template #cell(ItemName)="data">
<span class="text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
</template>
                <template #cell(Origin)="data">
<span class="text-capitalize">{{ data.item.origin ? data.item.origin.branch_name : '-' }}</span>
</template>
                <template #cell(CurrentLocation)="data">
<span class="text-capitalize">{{ data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-') }}</span>
</template>
                <template #cell(CurrentCondition)="data">
<span class="text-capitalize">{{ data.item.asset_condition }}</span>
</template>
                <template #cell(CurrentStatus)="data">
                  <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
{{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
</b-badge>
                </template>
                <template #cell(Thumbnail)="data">
                  <AssetPhotoAction
v-if="data.item.asset_photo"
:filename="data.item.asset_photo"
@preview="showPhotoPreview(data.item)"
/>
                  <div
v-else
class="text-center"
>
<b-badge variant="warning">
No Photo
</b-badge>
</div>
                </template>
                <template #cell(DateCreated)="data">
{{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(DateDisposed)="data">
{{ dateSimple(data.item.asset_disposed_date, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(actions)="data">
                  <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                    <template #button-content>
<feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
</template>
                    <b-dropdown-item @click="showDetailDisposal(data.item)">
<feather-icon icon="ZoomInIcon" /><span class="align-middle ml-50">Detail</span>
</b-dropdown-item>
                    <b-dropdown-item
                      v-if="['laboratory-manager', 'regional-manager', 'division-head', 'fa-coal-manager'].includes(userRole)"
                      @click="disposeApprovalRoute(data.item)"
                    >
<feather-icon icon="CheckCircleIcon" /><span class="align-middle ml-50">Confirm</span>
</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <DataTableFooter
                id="footer-dispose-na"
                :from="dataMetaNA.from"
                :to="dataMetaNA.to"
                :of="dataMetaNA.of"
                :total="totalItemsNA"
                :per-page="perPageNA"
                :current-page.sync="currentPageNA"
              />
            </b-tab>

            <b-tab title="Disposed">
              <DataTableToolbar
                id="toolbar-disposed"
                :branch.sync="filterBranchDisposed"
                :asset-group.sync="filterAssetGroupDisposed"
                :asset-status.sync="filterAssetStatusDisposed"
                :start-date.sync="startDateFilterDisposed"
                :end-date.sync="endDateFilterDisposed"
                :per-page.sync="perPageDisposed"
                :search-query.sync="searchQueryDisposed"
                :branches="branches"
                :asset-groups="assetGroups"
                :asset-status-options="assetStatusOptions"
                :per-page-options="perPageOptions"
                :is-loading-excel="exportLoading.disposed.xlsx"
                :is-loading-pdf="exportLoading.disposed.pdf"
                @export-excel="exportAsset('disposed', 'xlsx')"
                @export-pdf="exportAsset('disposed', 'pdf')"
              />
              <b-table
                ref="refAssetsListTableDisposed"
                class="position-relative"
                :items="fetchAssetsDisposed"
                responsive
                :fields="tableColumnsDisposed"
                primary-key="id"
                :sort-by.sync="sortByDisposed"
                :sort-desc.sync="isSortDirDescDisposed"
                show-empty
                empty-text="No matching records found"
              >
                <template #table-busy>
                  <shimmer-table-rows
                    :rows="Math.min(perPageDisposed, 8)"
                    :columns="tableColumnsDisposed.length - 1"
                  />
                </template>
                <template #cell(AssetID)="data">
                  <span class="text-capitalize">{{ data.item.asset_number }}</span>
                  <label
v-if="isOldAsset(data.item)"
class="ml-1 mb-0 badge badge-secondary"
>Old</label>
                  <label
v-else
class="ml-1 mb-0 badge badge-success"
>New</label>
                </template>
                <template #cell(ItemName)="data">
<span class="text-capitalize">{{ data.item.item ? data.item.item.item_name : '-' }}</span>
</template>
                <template #cell(Origin)="data">
<span class="text-capitalize">{{ data.item.origin ? data.item.origin.branch_name : '-' }}</span>
</template>
                <template #cell(CurrentLocation)="data">
<span class="text-capitalize">{{ data.item.current ? data.item.current.branch_name : (data.item.origin ? data.item.origin.branch_name : '-') }}</span>
</template>
                <template #cell(CurrentCondition)="data">
<span class="text-capitalize">{{ data.item.asset_condition }}</span>
</template>
                <template #cell(CurrentStatus)="data">
                  <b-badge :variant="resolveStatusVariant(data.item.asset_status)">
{{ data.item.asset_status ? data.item.asset_status.toUpperCase() : 'ACTIVE' }}
</b-badge>
                </template>
                <template #cell(Thumbnail)="data">
                  <AssetPhotoAction
v-if="data.item.asset_photo"
:filename="data.item.asset_photo"
@preview="showPhotoPreview(data.item)"
/>
                  <div
v-else
class="text-center"
>
<b-badge variant="warning">
No Photo
</b-badge>
</div>
                </template>
                <template #cell(DateCreated)="data">
{{ dateSimple(data.item.asset_created_time, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(DateDisposed)="data">
{{ dateSimple(data.item.asset_disposed_confirmed_by_fa_coal_manager_date, 'YYYY-MM-DD HH:mm:ss') }}
</template>
                <template #cell(actions)="data">
                  <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                    <template #button-content>
<feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
</template>
                    <b-dropdown-item @click="showDetailDisposal(data.item)">
<feather-icon icon="ZoomInIcon" /><span class="align-middle ml-50">Detail</span>
</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <DataTableFooter
                id="footer-disposed"
                :from="dataMetaDisposed.from"
                :to="dataMetaDisposed.to"
                :of="dataMetaDisposed.of"
                :total="totalItemsDisposed"
                :per-page="perPageDisposed"
                :current-page.sync="currentPageDisposed"
              />
            </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-modal
      id="modal-photo"
      v-model="isPhotoModalVisible"
      title="Asset Photo Preview"
      size="lg"
      centered
    >
      <div
v-if="selectedPhoto"
class="text-center"
>
        <img
          :src="modalPhotoUrl"
          :alt="`Asset ${selectedPhoto.asset_number}`"
          class="img-fluid"
          style="max-width: 100%; max-height: 500px;"
          @error="handlePhotoError"
        >
        <p class="mt-3">
<strong>Filename:</strong> {{ selectedPhoto.asset_photo }}
</p>
        <p><strong>Asset:</strong> {{ selectedPhoto.asset_number }}</p>
      </div>
      <template #modal-footer>
        <b-button
variant="primary"
@click="downloadPhoto"
>
          <feather-icon icon="DownloadIcon" /> Download
        </b-button>
        <b-button @click="isPhotoModalVisible = false">
Close
</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTable, BBadge,
  BTabs, BTab, BDropdown, BDropdownItem,
  BFormFile, BForm, BModal,
} from 'bootstrap-vue'
import axios from 'axios'
import store from '@/store'
import moment from 'moment-timezone'
import { getUserData } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { onUnmounted } from '@vue/composition-api'
import { saveAs } from 'file-saver'
import ShimmerCardGrid from '@core/components/skeleton/ShimmerCardGrid.vue'
import ShimmerTableRows from '@core/components/skeleton/ShimmerTableRows.vue'
import apiEndpoints from '@/constants/apiEndpoints'
import listPagePersistence from '@/mixins/listPagePersistence'
import AssetsList from './List'
import AssetPhotoAction from './AssetPhotoAction.vue'
import DataTableToolbar from './DataTableToolbar.vue'
import DataTableFooter from './DataTableFooter.vue'
import photoMixin from './mixins/photoMixin'

export default {
  components: {
    AssetPhotoAction,
    DataTableToolbar,
    DataTableFooter,
    ShimmerCardGrid,
    ShimmerTableRows,
    BTabs,
    BTab,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BFormFile,
    BForm,
    BModal,
  },
  mixins: [photoMixin, listPagePersistence([
    'currentPage', 'currentPageDisposed', 'currentPageNA', 'currentPageOnGoing',
    'currentPageUpdateNA', 'currentPageUpdateOnGoing', 'currentPageUpdated',
    'activeOuterTab', 'activeUpdateStatusTab', 'activeDisposeStatusTab',
  ])],
  data() {
    return {
      activeOuterTab: 0,
      activeUpdateStatusTab: 0,
      activeDisposeStatusTab: 0,
      showModal: false,
      isPhotoModalVisible: false,
      selectedPhoto: null,
      modalPhotoUrl: null,
      assetToDispose: null,
      file: '',
      modalUpload: false,
      materialRequestId: '',
      userId: getUserData().user_id,
      userRole: '',
      documentsList: [],
      exportLoading: {
        active: { xlsx: false, pdf: false },
        updateOnGoing: { xlsx: false, pdf: false },
        updateNA: { xlsx: false, pdf: false },
        updated: { xlsx: false, pdf: false },
        disposeOnGoing: { xlsx: false, pdf: false },
        disposeNA: { xlsx: false, pdf: false },
        disposed: { xlsx: false, pdf: false },
      },
      photoStatus: {},
      branches: [],
      alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      assetGroups: [
        'Machinery (MC)',
        'Furniture & Fixture',
        'Office Equipment',
        'Lab Equipment',
        'Vehicle (VH)',
        'Building',
        'Software',
        'Low Value Asset',
        'Land',
      ],
    }
  },
  setup() {
    const BRANCH_APP_STORE_MODULE_NAME = 'app-assets'
    onUnmounted(() => {
      if (store.hasModule(BRANCH_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(BRANCH_APP_STORE_MODULE_NAME)
      }
    })
    return { ...AssetsList() }
  },
  computed: {
    groupedActiveCards() {
      const groups = {}
      this.activeCardItems.forEach(item => {
        const name = item.item ? item.item.item_name : ''
        const first = (name || '').trim().charAt(0).toUpperCase()
        const letter = /[A-Z]/.test(first) ? first : '#'
        if (!groups[letter]) groups[letter] = []
        groups[letter].push(item)
      })
      return Object.keys(groups)
        .sort()
        .map(letter => ({ letter, items: groups[letter] }))
    },
    availableLetters() {
      return new Set(this.groupedActiveCards.map(group => group.letter))
    },
  },
  mounted() {
    this.userRole = this.$cookies.get('UserRole')
    this.$root.$on('refreshTable', this.refreshAllTables)
    this.getBranches()
    if (this.viewMode === 'card') {
      this.fetchActiveCardData()
    }
  },
  beforeDestroy() {
    this.$root.$off('refreshTable', this.refreshAllTables)
  },
  methods: {
    scrollToLetter(letter) {
      const el = document.getElementById(`asset-letter-${letter}`)
      if (el && this.$refs.assetCardScrollArea) {
        this.$refs.assetCardScrollArea.scrollTo({
          top: el.offsetTop - 8,
          behavior: 'smooth',
        })
      }
    },
    isOldAsset(item) {
      return (item && (item.asset_purchase_order_purchasing_receive_id == null
        && item.asset_purchase_order_warehouse_receive_id == null))
    },

    async showPhotoPreview(asset) {
      this.selectedPhoto = asset
      this.modalPhotoUrl = null
      this.isPhotoModalVisible = true
      this.modalPhotoUrl = await this.fetchPhotoUrl(asset.asset_photo)
    },
    async downloadPhoto() {
      if (!this.selectedPhoto || !this.selectedPhoto.asset_photo) return
      const url = this.modalPhotoUrl || await this.fetchPhotoUrl(this.selectedPhoto.asset_photo)
      if (!url) {
        this.toast('danger', 'Download failed', 'AlertTriangleIcon', 'Could not retrieve photo URL')
        return
      }
      const link = document.createElement('a')
      link.href = url
      link.download = this.selectedPhoto.asset_photo
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handlePhotoError() {
      this.toast('danger', 'Photo Load Error', 'AlertTriangleIcon', 'Image failed to load')
    },

    navigateToAddAsset() {
      localStorage.removeItem('assetDetail')
      this.$router.push({ name: 'apps-assets-create' }).catch(err => {
        if (err.name !== 'NavigationDuplicated') console.error(err)
      })
    },
    showConfirmationModal(asset) {
      this.assetToDispose = asset
      this.showModal = true
    },
    hideModal() { this.showModal = false },
    disposeAsset() {
      if (!this.assetToDispose) { this.hideModal(); return }
      this.disposeAssetRoute(this.assetToDispose)
      this.hideModal()
    },
    disposeAssetRoute(data) {
      localStorage.setItem('assetDetail', JSON.stringify(data))
      this.$router.push({ name: 'apps-assets-dispose-finance' })
    },
    updateAsset(data) {
      localStorage.setItem('assetDetail', JSON.stringify(data))
      this.$router.push({ name: 'apps-assets-update-finance' })
    },
    showDetail(item) {
      localStorage.setItem('assetDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-assets-detail' })
    },
    showDetailDisposal(item) {
      localStorage.setItem('assetDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-assets-dispose-detail' })
    },
    showHistory(item) {
      localStorage.setItem('assetDetail', JSON.stringify(item))
      this.$router.push({ name: 'apps-assets-history' })
    },
    showUpdateApproval(item) {
      localStorage.setItem('assetDetail', JSON.stringify(item))
      const userData = this.$cookies.get('userData')
      const roleSlug = userData && userData.role ? userData.role.role_slug : ''
      const routeMap = {
        'laboratory-manager': 'apps-assets-update-lab-manager',
        'regional-manager': 'apps-assets-update-regional-manager',
        'division-head': 'apps-assets-update-division-head',
        'fa-coal-manager': 'apps-assets-update-fa-coal-manager',
      }
      const routeName = routeMap[roleSlug] || 'apps-assets-update-detail'
      this.$router.push({ name: routeName })
    },
    disposeApprovalRoute(item) {
      localStorage.setItem('assetDetail', JSON.stringify(item))
      const userData = this.$cookies.get('userData')
      const roleSlug = userData && userData.role ? userData.role.role_slug : ''
      const routeMap = {
        'laboratory-manager': 'apps-assets-dispose-lab-manager',
        'regional-manager': 'apps-assets-dispose-regional-manager',
        'division-head': 'apps-assets-dispose-division-head',
        'fa-coal-manager': 'apps-assets-dispose-fa-coal-manager',
      }
      const routeName = routeMap[roleSlug] || 'apps-assets-dispose-detail'
      this.$router.push({ name: routeName })
    },

    refreshAllTables() {
      if (this.viewMode === 'card') {
        this.fetchActiveCardData()
      }
      const refs = [
        'refAssetsListTable',
        'refAssetsListTableUpdateOnGoing',
        'refAssetsListTableUpdateNA',
        'refAssetsListTableUpdated',
        'refAssetsListTableOnGoing',
        'refAssetsListTableNA',
        'refAssetsListTableDisposed',
      ]
      refs.forEach(key => {
        const ref = this.$refs[key]
        if (ref && typeof ref.refresh === 'function') ref.refresh()
      })
    },

    getBranches() {
      const headers = this.authHeaders()
      axios
        .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_BRANCHES}`, { headers })
        .then(response => {
          const userData = this.$cookies.get('userData')
          const userBranch = userData ? userData.branch : null
          this.branches = response.data.data
            .filter(elem => {
              if (userBranch === null || typeof userBranch === 'undefined') return true
              return elem.branch_code === userBranch.branch_code
            })
            .map(elem => ({
              label: `${elem.branch_name} (${elem.branch_code})`,
              value: elem.branch_id,
            }))
        })
        .catch(() => {})
    },

    exportAsset(tabKey, format) {
      const isPdf = format === 'pdf'
      const flagKey = isPdf ? 'pdf' : 'xlsx'
      this.exportLoading[tabKey][flagKey] = true

      const cfg = this.getExportConfig(tabKey)
      const params = { ...cfg.params }
      if (cfg.startDate) params.date_start = cfg.startDate
      if (cfg.endDate) params.date_end = cfg.endDate
      if (cfg.search) params.search = cfg.search
      if (cfg.branchId) params.branch_id = cfg.branchId
      if (cfg.group) params.group = cfg.group
      if (cfg.assetStatus === 'old') params.is_old = 'true'
      else if (cfg.assetStatus === 'new') params.is_old = 'false'
      if (isPdf) params.format = 'pdf'

      axios
        .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_EXPORT_ASSET}`, {
          headers: this.authHeaders(),
          responseType: 'arraybuffer',
          params,
        })
        .then(response => {
          let filename = `report_assets_${tabKey}`
          if (cfg.startDate) filename += `_${cfg.startDate}`
          if (cfg.endDate) filename += `_${cfg.endDate}`
          filename += isPdf ? '.pdf' : '.xlsx'

          const mime = isPdf ? 'application/pdf' : response.headers['content-type']
          saveAs(new Blob([response.data], { type: mime }), filename)
          this.toast('success', isPdf ? 'PDF Export Success' : 'Export Success', 'CheckIcon')
        })
        .catch(err => {
          this.toast('danger', isPdf ? 'PDF Export Failed' : 'Export Failed', 'AlertTriangleIcon')
        })
        .finally(() => {
          this.exportLoading[tabKey][flagKey] = false
        })
    },
    getExportConfig(tabKey) {
      const pickVal = v => (v && typeof v === 'object' ? v.value : v)
      const pickGroup = v => {
        if (!v) return ''
        return typeof v === 'object' ? (v.value || v.label || '') : v
      }
      const map = {
        active: {
          params: { type: 'ongoing' },
          startDate: this.startDateFilter,
          endDate: this.endDateFilter,
          search: this.searchQuery,
          branchId: pickVal(this.filterBranch),
          group: pickGroup(this.filterAssetGroup),
          assetStatus: pickVal(this.filterAssetStatus),
        },
        updateOnGoing: {
          params: { is_ongoing_update: 'true' },
          startDate: this.startDateFilterUpdateOnGoing,
          endDate: this.endDateFilterUpdateOnGoing,
          search: this.searchQueryUpdateOnGoing,
          branchId: pickVal(this.filterBranchUpdateOnGoing),
          group: pickGroup(this.filterAssetGroupUpdateOnGoing),
          assetStatus: pickVal(this.filterAssetStatusUpdateOnGoing),
        },
        updateNA: {
          params: { needs_approval_update: 'true', is_ongoing_update: 'true' },
          startDate: this.startDateFilterUpdateNA,
          endDate: this.endDateFilterUpdateNA,
          search: this.searchQueryUpdateNA,
          branchId: pickVal(this.filterBranchUpdateNA),
          group: pickGroup(this.filterAssetGroupUpdateNA),
          assetStatus: pickVal(this.filterAssetStatusUpdateNA),
        },
        updated: {
          params: { is_updated: 'true', is_ongoing_update: 'true' },
          startDate: this.startDateFilterUpdated,
          endDate: this.endDateFilterUpdated,
          search: this.searchQueryUpdated,
          branchId: pickVal(this.filterBranchUpdated),
          group: pickGroup(this.filterAssetGroupUpdated),
          assetStatus: pickVal(this.filterAssetStatusUpdated),
        },
        disposeOnGoing: {
          params: { is_ongoing_dispose: 'true' },
          startDate: this.startDateFilterOnGoing,
          endDate: this.endDateFilterOnGoing,
          search: this.searchQueryOnGoing,
          branchId: pickVal(this.filterBranchOnGoing),
          group: pickGroup(this.filterAssetGroupOnGoing),
          assetStatus: pickVal(this.filterAssetStatusOnGoing),
        },
        disposeNA: {
          params: { needs_approval: 'true', is_ongoing_dispose: 'true' },
          startDate: this.startDateFilterNA,
          endDate: this.endDateFilterNA,
          search: this.searchQueryNA,
          branchId: pickVal(this.filterBranchNA),
          group: pickGroup(this.filterAssetGroupNA),
          assetStatus: pickVal(this.filterAssetStatusNA),
        },
        disposed: {
          params: { is_disposed: 'true', is_ongoing_dispose: 'true' },
          startDate: this.startDateFilterDisposed,
          endDate: this.endDateFilterDisposed,
          search: this.searchQueryDisposed,
          branchId: pickVal(this.filterBranchDisposed),
          group: pickGroup(this.filterAssetGroupDisposed),
          assetStatus: pickVal(this.filterAssetStatusDisposed),
        },
      }
      return map[tabKey] || map.active
    },

    showDocuments(id) {
      this.materialRequestId = id
      this.modalUpload = true
      axios
        .get(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_GET_DOCUMENTS}mr/${id}`, {
          headers: this.authHeaders(),
        })
        .then(response => {
          if (response.data.success === true && response.data.data) {
            this.documentsList = [...response.data.data]
            this.toast('success', 'Fetching Documents success', 'CheckIcon')
          } else {
            this.toast('danger', 'Fetching Documents failed', 'AlertTriangleIcon')
          }
        })
    },
    handleFilesUpload(e) {
      this.file = e.target.files || e.dataTransfer.files
    },
    sendDocument() {
      if (!this.file || typeof this.file[0] === 'undefined') {
        this.toast('danger', 'Please Upload The Document!', 'AlertTriangleIcon')
        return
      }
      const formData = new FormData()
      formData.append('file', this.file[0], this.file[0].name)
      formData.append('document_asset_id', this.materialRequestId)
      formData.append('time', moment())

      axios
        .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_CREATE_DOCUMENT}`, formData, {
          headers: {
            ...this.authHeaders(),
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.data.success === true) {
            this.refetchData()
            this.$refs.uploadFile.reset()
            this.showDocuments(this.materialRequestId)
            this.toast('success', 'Upload Document Success', 'CheckIcon')
          } else {
            this.toast('danger', 'Something went wrong', 'AlertTriangleIcon')
          }
        })
    },
    deleteAttachment(document) {
      const fileName = document.document_file_name
      const body = {
        ObjectName: `${document.document_number}${fileName}`,
        FileName: fileName,
        id: document.document_id,
      }
      axios
        .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_DELETE_ASSET}`, body, {
          headers: this.authHeaders(),
        })
        .then(response => {
          if (response.data.Status === 1) {
            this.showDocuments(document.document_asset_id)
            this.toast('success', 'Delete Attachment success', 'CheckIcon')
          } else {
            this.toast('danger', 'Something went wrong', 'AlertTriangleIcon')
          }
        })
    },
    downloadAttachment(document) {
      const fileName = document.document_file_name
      const body = {
        ObjectName: `${document.document_number}${fileName}`,
        FileName: fileName,
      }
      axios
        .post(`${process.env.VUE_APP_API_URL}${apiEndpoints.API_DOWNLOAD_ASSET}`, body, {
          headers: this.authHeaders(),
        })
        .then(response => {
          if (response.data.Status === 1) {
            window.open(response.data.Payload, '_blank')
            this.toast('success', 'Download Attachment success', 'CheckIcon')
          } else {
            this.toast('danger', 'Something went wrong', 'AlertTriangleIcon')
          }
        })
    },

    authHeaders() {
      return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.$cookies.get('userToken')}`,
      }
    },
    toast(variant, title, icon = 'CheckIcon', text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
          text,
        },
      })
    },
    dateSimple(value, format = 'YYYY-MM-DD') {
      return value ? moment.utc(value).tz('Asia/Jakarta').format(format) : null
    },
    hasPermission(permission) {
      const cookieVal = this.$cookies.get('userPermissions')
      const permissions = (cookieVal || '').split(',')
      return permissions.includes(permission)
    },
    cutString(string, length = 30) {
      if (!string) return '-'
      return string.length > length ? `${string.substring(0, length)} ...` : string
    },
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// --- View switcher ---------------------------------------------------
.view-switch {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem;
  border: 1px solid #ebe9f1;
  border-radius: 999px;
  background: #f8f8fc;
}

.view-switch__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.32rem 0.75rem;
  color: #6e6b7b;
  border: 0;
  border-radius: 999px;
  background: transparent;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(&--active) {
    color: #2b8a7e;
  }

  &--active {
    color: #fff;
    background: linear-gradient(135deg, #2b8a7e 0%, #255f85 100%);
    box-shadow: 0 4px 10px rgba(43, 138, 126, 0.28);
  }
}

// --- Card view ---------------------------------------------------------
.asset-cards {
  position: relative;
  min-height: 220px;
  padding: 0 1.25rem 0.5rem;
}

.asset-cards__loading {
  padding-top: 0.25rem;
}

.asset-cards__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 3.5rem 1rem;
  color: #b9b9c3;
}

.asset-cards__body {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.asset-cards__scroll {
  flex: 1 1 auto;
  min-width: 0;
  max-height: 640px;
  overflow-y: auto;
  padding-right: 0.35rem;
  scroll-behavior: smooth;
}

.asset-cards__group {
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0.25rem;
  }
}

.asset-cards__group-heading {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  padding: 0.4rem 0.6rem;
  margin-bottom: 0.75rem;
  border-radius: 8px;
  background: rgba(247, 248, 251, 0.94);
  backdrop-filter: blur(3px);

  span {
    color: #2b8a7e;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: 0.02em;
  }

  em {
    color: #b9b9c3;
    font-size: 0.72rem;
    font-style: normal;
  }
}

.asset-cards__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 1rem;
}

.asset-card {
  position: relative;
  padding: 1rem 1rem 0.9rem;
  border: 1px solid #eeeef4;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(24, 30, 48, 0.04);
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;

  &:hover {
    transform: translateY(-3px);
    border-color: rgba(43, 138, 126, 0.25);
    box-shadow: 0 14px 28px rgba(24, 30, 48, 0.1);
  }
}

.asset-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 0.65rem;
}

.asset-card__icon {
  display: grid;
  width: 46px;
  height: 46px;
  place-items: center;
  color: #2b8a7e;
  border-radius: 50%;
  background: rgba(43, 138, 126, 0.12);
}

.asset-card__menu {
  margin-top: -0.35rem;
  margin-right: -0.5rem;
}

.asset-card__name {
  margin: 0 0 0.5rem;
  overflow: hidden;
  color: #1f2a44;
  font-size: 0.95rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-transform: capitalize;
}

.asset-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
}

.asset-card__meta {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0;
  margin: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    overflow: hidden;
    color: #6e6b7b;
    font-size: 0.78rem;
    text-overflow: ellipsis;
    white-space: nowrap;

    svg {
      flex: 0 0 auto;
      color: #b9b9c3;
    }
  }
}

// --- A-Z rail ------------------------------------------------------------
.asset-cards__rail {
  position: sticky;
  top: 0.5rem;
  flex: 0 0 30px;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding: 0.5rem 0.2rem;
  border-radius: 999px;
  background: #f8f8fc;
}

.asset-cards__rail-letter {
  width: 20px;
  padding: 0.06rem 0;
  color: #c8c7d1;
  border: 0;
  background: transparent;
  font-size: 0.62rem;
  font-weight: 700;
  line-height: 1.35;
  transition: color 0.12s ease, transform 0.12s ease;

  &:disabled {
    cursor: default;
  }

  &--active {
    color: #255f85;
    cursor: pointer;

    &:hover {
      color: #2b8a7e;
      transform: scale(1.25);
    }
  }
}

@media (max-width: 767.98px) {
  .asset-cards {
    padding: 0 0.75rem 0.5rem;
  }

  .asset-cards__grid {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 0.75rem;
  }

  .view-switch__btn span {
    display: none;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
